module.exports = __webpack_public_path__ + "img/payments_re.baafaa3c.webp";